import { weixinApi } from '@/api/b2b-news';
import wx from 'weixin-js-sdk';
export default {
  methods: {
    getWxShareInfoData(options) {
      // 只针对微信环境
      if (window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') === -1) {
        return;
      }
      const params = {
        url: `${window.location.origin}/pubInfo/`,
        appId: 'wx9edce5ae6dc8cc9a',
      };
      weixinApi(params).then(res => {
        const { data, code } = res;
        if (Number(code) === 0) {
          const { timestamp, nonceStr, signature } = data;
          wx.config({
            debug: false,
            appId: 'wx9edce5ae6dc8cc9a',
            timestamp,
            nonceStr,
            signature,
            jsApiList: [
              'updateTimelineShareData', // 分享朋友圈
              'updateAppMessageShareData', //好友或群
              'onMenuShareWeibo',//分享到微博
            ], // 必填，需要使用的JS接口列表
          });
          const defaults = {
            title: '资讯',
            desc: ' ',
            imgUrl: `${window.location.origin}/pubInfo/img/ZXlogo.png`,
          };
          const shareOptions = Object.assign({}, defaults, options);
          wx.ready(function () {
            wx.updateAppMessageShareData({
              title: shareOptions.title,
              desc: shareOptions.desc,
              link: shareOptions.link,
              imgUrl: shareOptions.imgUrl,
              success: shareOptions.success, // 成功回调
            });
            wx.updateTimelineShareData({
              title: shareOptions.title, // 分享标题
              link: shareOptions.link, // 分享链接
              imgUrl: shareOptions.imgUrl, // 分享图标
              success: shareOptions.success, // 成功回调
            });
            // 分享到微博
            wx.onMenuShareWeibo({
              title: shareOptions.title, // 分享标题
              desc: shareOptions.desc, // 分享描述
              link: shareOptions.link, // 分享链接
              imgUrl: shareOptions.imgUrl, // 分享图标
              success: shareOptions.success, // 成功回调
              cancel: shareOptions.cancel, // 取消回调
            });
          });
        }
      });
    },
    handleErrorFn(e) {
      console.log('handleErrorFn', e.detail);
    },
    handleLaunchFn(e) {
      console.log('handleLaunchFn', e);
    },
  },
};
